import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';
import './styles.css';
import CustomTable from '../../../components/CustomTable';

import { APROBADO, REGISTRADO, ANULADO, RECHAZADO, IMPORTADO } from '../../../common/types/requerimientoEstadoType';

export default function DetalleIngreso(props) {
    const renderColor = (row) => {
        if (row.idRequerimientoEstado === REGISTRADO)
            return 'blue';
        if (row.idRequerimientoEstado === APROBADO)
            return 'green';
        if (row.idRequerimientoEstado === IMPORTADO)
            return 'gold';
        if (row.idRequerimientoEstado === RECHAZADO)
            return 'orange';
        if (row.idRequerimientoEstado === ANULADO)
            return 'red';
    };

    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[

                {
                    title: 'Serie',
                    dataIndex: 'serie',
                    key: 'serie',
                    sorter: true
                },
                {
                    title: 'Documento',
                    dataIndex: 'documento',
                    key: 'documento',
                    sorter: true
                },
                {
                    title: 'Tipo',
                    dataIndex: 'tipo',
                    key: 'tipo',
                    sorter: true
                },

                {
                    title: 'Número de Documento',
                    dataIndex: 'numeroDocumento',
                    key: 'numeroDocumento',
                    sorter: true
                },
                {
                    title: 'Proveedor',
                    dataIndex: 'razonSocial',
                    key: 'razonSocial',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },

                {
                    title: 'Proyecto',
                    dataIndex: 'proyecto',
                    key: 'proyecto',
                    sorter: true
                },

                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },


                {
                    title: 'Codigo Referencia',
                    dataIndex: 'codigoReferencia',
                    key: 'codigoReferencia',
                    sorter: true
                },

                {
                    title: 'Nombre',
                    dataIndex: 'nombre',
                    key: 'nombre',
                    sorter: true
                },
                {
                    title: 'Cantidad',
                    dataIndex: 'cantidad',
                    key: 'cantidad',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },
                {
                    title: 'Estado',
                    dataIndex: 'nombreRequerimientoEstado',
                    key: 'nombreRequerimientoEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );

}
